export const PRO_PLAN_FEATURES = [
  '',
  'Get more projects',
  'Export anywhere',
  'SEO & Analytics',
  'Project templates',
  'Link blocks with symbols',
  'Add tags to track progress',
  'Password protect',
  'Guest comments',
]

export const PRO_AMOUNT = 16
